import type { DiscoveredRouteModule } from '@/router/generator/types';

// This legacy top-level Directory route duplicates directory-children.route.
// Keep file to avoid discovery name collision by exporting a no-op disabled route.
export const route: DiscoveredRouteModule = {
  id: 'app.directory.legacy',
  scope: 'app',
  moduleKey: 'directory',
  name: '__LegacyDirectoryPlaceholder__',
  path: '__legacy-directory__',
  component: () => import('@/views/DirectoryView.vue'),
  meta: { disabled: true },
};


